import { useView } from '../app/use-view.ts'
import styles from './hold-ring.module.css'

/**
 * Around the crosshair while a press is held (eat, drop, a hold-to-use interactable): a ring
 * that fills over the hold's seconds. A new hold restarts it. It's feedback the player acts
 * on, so it keeps moving under reduced motion.
 */
export function HoldRing() {
  const hold = useView((view) => view.hud.hold)
  if (!hold) return null
  return (
    <svg key={hold.id} class={styles.ring} viewBox="0 0 36 36" aria-hidden="true">
      <circle class={styles.track} cx="18" cy="18" r="16" pathLength={1} />
      <circle
        class={styles.fill}
        cx="18"
        cy="18"
        r="16"
        pathLength={1}
        style={{ animationDuration: `${String(hold.seconds)}s` }}
      />
    </svg>
  )
}
